import useClockInOut from './useClockInOut'

const useClockOut = (revisionId: string) => {
  const { clockInOut, ...others } = useClockInOut({ type: 'out', revisionId })

  return {
    ...others,
    clockOut: clockInOut
  }
}

export default useClockOut
